import { INotice, Notifier } from '@airbrake/browser';

const defaultErrorMessage = 'uknown error';
const apiHandledError = 'Please fix errors below';

const windowAny : any = window;
const baseApiEnv = windowAny?.bootstrap?.apiEnvironment || 'localhost';

const airbrake = new Notifier({
	projectId: 419205,
	projectKey: '2ed7382e78bfb3f97d5f7ae9b5fadf03',
	environment: window?.location?.host?.includes('localhost') ? 'localhost' : baseApiEnv,
  });

export async function RegisterErrorAsync(error: any, apiUrl: string, method: string, headers: any, airbrakeNotify: (err: any) => Promise<INotice> = null): Promise<boolean> {
	try {		
		const pageUrl = window.location.href;

		let message = (error?.response?.data?.status?.message as string) || (error?.message as string);
		const type = error.response ? error.response.status : error.code;

		if (!message && error){
			message = JSON.stringify(error);
		}

		if (message?.toLocaleLowerCase().includes(apiHandledError.toLocaleLowerCase())){
			return true;
		}

		const remoteNotify: (err: any) => Promise<INotice> = airbrakeNotify || airbrake.notify;

		const notice = await remoteNotify({
			error: message || defaultErrorMessage,
			params: {
				api_url: apiUrl,
				method,
				token: headers?.Authorization,
				audit_app: headers ? headers['audit-app'] : '',
				page_url: pageUrl,
				type: type || '',
				api_env: baseApiEnv,
			},
		  });	
	
		 return notice?.id !== null; 
	} catch (errorAirbreak) {
		// eslint-disable-next-line no-console
		console.log(`Error could not be registered on air break: '${errorAirbreak}'`);
		return false;
	}
}

